import {MessageCircle} from "lucide-react";
import {MessageItem} from "../../../components/MessageItem.tsx";
import React from "react";
import {FullMessage} from "../../../api/ApiTypes.ts";

interface MessagesTabProps {
    orderId?: number
    messages?: FullMessage[]
}


export const MessagesTab: React.FC<MessagesTabProps> = ({ orderId, messages }) => {

    if (!orderId) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <p className="text-slate-500">Order ID is not available.</p>
            </div>
        )
    }

    // Handle case when no messages exist or array is empty
    if (!messages || messages.length === 0) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <MessageCircle className="h-10 w-10 text-slate-400 mx-auto mb-2" />
                <p className="text-slate-500">No messages exist for this order.</p>
            </div>
        );
    }

    // Filter out hidden messages and sort by date (newest first)
    const visibleMessages = messages
        .filter(message => !message.hide)
        .sort((a, b) =>
            new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
        );

    if (visibleMessages.length === 0) {
        return (
            <div className="bg-white rounded-lg p-6 text-center border border-slate-200">
                <MessageCircle className="h-10 w-10 text-slate-400 mx-auto mb-2" />
                <p className="text-slate-500">No visible messages are available for this order.</p>
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <h2 className="text-lg font-medium text-slate-800 mb-4">Order Messages</h2>

            {visibleMessages.map(message => (
                <MessageItem key={message.id} message={message} />
            ))}
        </div>
    );
};